import { Component, OnInit } from '@angular/core';
import { UIRouter, Transition } from "@uirouter/angular";

import { ApiService } from "../api-service/api.service"
import { RewardsService } from "../rewards-service/rewards.service"
import swal from "sweetalert2";

@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.less']
})
export class RewardsComponent implements OnInit {

  private rewardsData: any

  constructor(
    private router: UIRouter, private apiService: ApiService, private rewardsService: RewardsService) { }

  closeSidebar(reward) {

    this.router.stateService.go('app.rewards')

  }

  openEditReward(id) {

    this.router.stateService.go('app.rewards.edit', { rewardID: id })

  }

  retrieveRewards() {

    this.apiService.request('GET', '/rewards')
      .then((response) => {

        this.rewardsData.next(response)

      })
      .catch(error => {
        console.log(error)
      })

  }

  deleteRewardCode(id) {

    swal({
      title: "Are you sure you want to delete this reward?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#149fba",
      confirmButtonText: "Yes, delete",

    })
      .then((selection) => {
        this.apiService.request('DELETE', '/reward/' + id)
          .then((response) => {
            this.rewardsService.retrieveRewards()
          })
          .catch((error) => {

          })

      })
      .catch(swal.noop);

    console.log('delete')
  }

  ngOnInit() {

    this.rewardsService.retrieveRewards()

    this.rewardsService.rewards.subscribe((x) => {
      this.rewardsData = x
      console.log("RewardsComponent -> this.rewardsData", this.rewardsData)

    })

  }

}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/worryandpeace/valhalla/src/app/rewards/rewards.component.ts